import React from 'react';
import { getWindSpeedClass, getWindIndicator } from '../../../utils/helpers';

const WindSpeedMax10mRow = ({dayData, units}) => {

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 py-1 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        <span className="block">Wind<br />km/h</span>
                    </div>
                </div>
            </td>
            {dayData.map((value, index) => {
                const windSpeed = dayData?.[index];
                const windSpeedClass = getWindSpeedClass(windSpeed);
                const windIndicator = getWindIndicator(windSpeed);
                return (
                    <td key={index} className="py-1 text-center">
                        <div className="inline-flex flex-col items-center gap-1">
                            <div className="flex justify-center">{windIndicator}</div>
                            <div className={`inline-block min-w-[30px] text-center text-sm font-medium ${windSpeedClass}`}>
                                {Math.round(windSpeed)}
                            </div>
                        </div>
                    </td>
                );
            })}
        </tr>
    )
}

export default WindSpeedMax10mRow;